import appleStore from './AppleStore.png';
import googlePlay from './GooglePlay.png';
import imagenDashboard from './ImagenDashboard.svg';
import loginImage from './LoginImage.png';
import pdf from './pdfIcon.svg';
import doc from './docIcon.svg';
import uploadFiles from './uploadfiles.svg';
import addDocument from './addDocument.svg';
import meet from './meet.svg';
import certificate from './certificate.png';
import noCertificate from './no_certificate.png';
import manualEvaluationIcon from './manualEvaluationIcon.png';
import autoEvaluationIcon from './autoEvaluationIcon.png';
import achievement1IconNC from './achievement1_nc.png';
import achievement2IconNC from './achievement2_nc.png';
import achievement3IconNC from './achievement3_nc.png';
import achievement4IconNC from './achievement4_nc.png';
import achievement1IconC from './achievement1_c.png';
import achievement2IconC from './achievement2_c.png';
import achievement3IconC from './achievement3_c.png';
import achievement4IconC from './achievement4_c.png';

import LogoBlack from './logo_black.png';
import LogoWhite from './logo_white.png';
import LogoWhiteSquare from './logo_white_square.png';
import LogoWhiteRounded from './logo_white_rounded.png';
import mexlogImageFallback from './mexlog-image-fallback.jpg';

export const AppleStore = appleStore;
export const GooglePlay = googlePlay;
export const ImagenDashboard = imagenDashboard;
export const LoginImage = loginImage;
export const Pdf = pdf;
export const Doc = doc;
export const UploadFiles = uploadFiles;
export const AddDocument = addDocument;
export const Meet = meet;
export const Certificate = certificate;
export const NoCertificate = noCertificate;
export const ManualEvaluationIcon = manualEvaluationIcon;
export const AutoEvaluationIcon = autoEvaluationIcon;
export const Achievement1IconNC = achievement1IconNC;
export const Achievement2IconNC = achievement2IconNC;
export const Achievement3IconNC = achievement3IconNC;
export const Achievement4IconNC = achievement4IconNC;
export const Achievement1IconC = achievement1IconC;
export const Achievement2IconC = achievement2IconC;
export const Achievement3IconC = achievement3IconC;
export const Achievement4IconC = achievement4IconC;

export const LogoKappaBlack = LogoBlack;
export const LogoKappaWhite = LogoWhite;
export const LogoKappaWhiteSquare = LogoWhiteSquare;
export const LogoKappaWhiteRounded = LogoWhiteRounded;

export const MexlogImageFallback = mexlogImageFallback;
